import { Pipe, PipeTransform } from '@angular/core';
import {DecimalPipe, PercentPipe} from '@angular/common'

@Pipe({
  name: 'numstring'
})
export class NumstringPipe implements PipeTransform {

  transform(value: string | number, args?: any): any {
    if(typeof value === 'string') {
      return value;
    }else {
      return new DecimalPipe('en-US').transform(value)
    }
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src946329470/src/frontend/src/app/utils/numstring.pipe.ts